<template>
  <v-sheet style="background-color: #001E4A;">
    <v-container class="mt-12 mb-12">
      <v-row class="ma-1">
        <v-img
          :max-height="$vuetify.breakpoint.lgAndUp ? 'calc(100vh - 0px)' : '1000'"
          :src="Products"
          alt=""
          style="margin-left: auto; margin-right: auto;"
        ></v-img>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import Products from 'Assets/Produtos/products.png';
export default {
  name: 'Specialty',
  data() {
    return {
      Products,
    };
  },
  components: {},
};
</script>
